/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'logs': {
    width: 200,
    height: 200,
    viewBox: '0 0 1024 1024',
    data: '<defs/><path pid="0" d="M392.512 584.897S500.032 492.48 693.632 512c6.464.64 12.736 1.344 18.752 2.048 27.776-37.12 55.936-76.8 83.456-117.12l-267.072 1.28s112.896-101.312 290.368-81.728a792.919 792.919 0 0127.968 3.648c25.471-39.168 49.663-77.696 71.487-113.728l-206.975-5.504s141.247-85.632 255.231-76.608C1008.64 50.05 1031.871-.318 1021.567.002 254.464 24.897.001 1024 .001 1024h73.472C128.129 915.776 250.88 716.416 250.88 716.416s121.856 48 259.84 3.584c35.2-11.328 88.256-63.935 147.008-135.935l-265.216.832z"/>'
  }
})
